import { Box, Stack, Typography } from "@mui/material";

import { POSITIONS } from "./filters";

/**
 * Position group selector, shared by both views — but it does a different job in
 * each, which is why the label is a prop rather than baked in.
 *
 * On the league table it selects rows: show me the guards. On the player page it
 * selects the *comparison population*: rank him against the centers, whatever he
 * is himself. Same control, same state, opposite side of the ranking — see
 * `PopulationFilters` in `filters.ts`.
 */
export default function PositionChips({
  value,
  onChange,
  label,
}: {
  value: string;
  onChange: (position: string) => void;
  label: string;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.1em",
          color: "#8a8a8a",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
      <Stack direction="row">
        {POSITIONS.map((option, index) => (
          <Box
            key={option}
            role="button"
            tabIndex={0}
            aria-pressed={value === option}
            onClick={() => onChange(option)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange(option);
              }
            }}
            sx={{
              minWidth: 34,
              textAlign: "center",
              px: 1,
              py: 0.85,
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: "0.05em",
              cursor: "pointer",
              userSelect: "none",
              border: "1px solid",
              // Shared edges rather than doubled ones, so the group reads as one
              // segmented control.
              borderLeft: index ? "none" : "1px solid",
              borderColor: value === option ? "#17191c" : "#dfe2e6",
              backgroundColor: value === option ? "#17191c" : "#fff",
              color: value === option ? "#fff" : "#3f4650",
            }}
          >
            {option}
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}
